import { useState, useEffect, forwardRef } from 'react'
import { Card, CardHeader, CardContent, CardActions, Button, Snackbar, OutlinedInput, InputAdornment, styled, Paper, Grid, Typography } from '@mui/material'
import { Computer, Key } from "@mui/icons-material"
import makeStyles from "@mui/styles/makeStyles"
import MuiAlert from "@mui/material/Alert"
import { emitTerminalFireLicenseUpdate } from "../utils/licenseBus";
import { useSnackbar } from "../providers/SnackbarProvider";

const useStyles = makeStyles({
    terminalLicenceKey: {
        width: "20rem",
        marginBottom: "0rem"
    },
    terminalLicenceCard: {
        padding: "1rem",
        marginTop: "1rem",
        marginBottom: "1rem"
    },
    terminalListLicenceCard: {
        padding: "1rem",
        textAlign: "center",
        marginTop: "1rem",
        marginBottom: "1rem"
    }
})

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ItemHeader = styled(Paper)(({ theme }) => ({
    backgroundColor: '#5E5E5E',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: '#fff',
    height: 'auto',
    width: '100%'
}));

export default function TerminalFireLicence(props) {
    const classes = useStyles()
    const [activateButton, setActivateButton] = useState(true)
    const [key, setKey] = useState("")
    const [severity, setSeverity] = useState("")
    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState("")
    const [licences, setLicences] = useState([])
    const { openSnackbar } = useSnackbar();

    //useEffect(() => {
    //    try {
    //        fetch(`${process.env.REACT_APP_URL}/licences/terminal/web/all?serialNumber=${props.systemData.serialKeys}`, {
    //            method: "GET",
    //            headers: {
    //                "content-type": "application/json",
    //                "Authorization": "Bearer " + props.token
    //            },
    //        }).then(response => response.json())
    //            .then(data => setLicences(data))
    //    }
    //    catch (e) {
    //         openSnackbar("erro ao buscar a licença")
    //    }

    //}, [])
    const load = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_URL}/licences/terminal/web/all?serialNumber=${props.systemData.serialKeys}`,
                {
                    method: "GET",
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + props.token
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const text = await response.text();
            console.log("RESPONSE TERMINAL LICENSE", text);
            const data = text ? JSON.parse(text) : [];

            autoActivateAllLicences(data);
            setLicences(data);
            emitTerminalFireLicenseUpdate(data);
        } catch (e) {
            openSnackbar("Erro ao buscar a licença","error");
            console.error("Erro no fetch:", e);
        }
    }
    const autoActivateAllLicences = async (data) => {
        const urlBase = `${process.env.REACT_APP_URL}/licences/auto-activate/terminal`;
        const token = props.token;

        const usedLicences = data.filter(item => item.chave_utilizada);

        const requests = usedLicences.map(item => {
            const key = item.chave;
            const serialNumber = props.systemData.serialKeys;

            return fetch(`${urlBase}?key=${key}&serialNumber=${serialNumber}`, {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            })
                .then(response => response.json())
                .catch(error => ({ error: error.message, key }));
        });

        if (requests.length === 0) {
            console.log("Nenhuma licença pendente para auto-ativação.");
            props.setActive(prev => prev + 1);

            return;
        }


        const results = await Promise.all(requests);

        console.log("Resultados da auto-ativação:", results);

        props.setActive(prev => prev + 1);

    };

    useEffect(() => {
        load();
    }, []);

    const keyLength = (e) => {
        if (e.length >= 10) {
            setKey(e)
            setActivateButton(false)
        } else {
            setActivateButton(true)
        }
    }

    const activateLicence = () => {
        setActivateButton(true);
        fetch(`${process.env.REACT_APP_URL}/licences/activate/terminal?key=${key}&serialNumber=${props.systemData.serialKeys}`, {
            method: "GET",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + props.token
            },
        })
        .then(response => response.json())
        .then(data => {
            if (data.message === "Success") {
                openSnackbar("Sua Licença foi ativada com sucesso!","success");
                props.setActive(1)
                load();
            }
            if (data.message === "Used") {
                openSnackbar("Esta chave já está em uso. Adquira uma nova chave.","error");
            }
            if (data.message === "Error") {
                openSnackbar("Erro ao ativar Licença!","error");
            }
            if (data.message === "NotFound") {
                openSnackbar("Chave não encontrada!","error");
            }
            if (data.message === "Invalid") {
                openSnackbar("Chave Inválida!","error");
            }
        })
            .finally(() => {
                setActivateButton(false);
        });
    }

    return (
        <>
            <Card elevation={4} className={classes.terminalLicenceCard}>
                <center>
                    <label><h4>Ativação da Licença</h4></label>
                </center>

                <CardContent>
                    <OutlinedInput
                        className={classes.terminalLicenceKey}
                        id="secret-key"
                        onChange={(e) => keyLength(e.target.value)}
                        variant="outlined"
                        color="secondary"
                        fullWidth={true}
                        required
                        //error={secretError}
                        startAdornment={
                            <InputAdornment position="start">
                                <Key />
                            </InputAdornment>
                        }
                    ></OutlinedInput>
                </CardContent>

                <CardActions>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth={true}
                        disabled={activateButton}
                        onClick={activateLicence}>
                        Ativar licença
                    </Button>

                </CardActions>
            </Card>
            
            <ItemHeader>
                <Grid container spacing={3}>
                    <Grid item xs={4} md={4} lg={4}>
                        <Typography variant="body2">Tipo de Licença</Typography>
                    </Grid>
                    <Grid item xs={4} md={4} lg={4}>
                        <Typography variant="body2">Chave</Typography>
                    </Grid>
                    <Grid item xs={4} md={4} lg={4}>
                        <Typography variant="body2">Status</Typography>
                    </Grid>
                </Grid>
            </ItemHeader>
            {
                licences.map(item => {
                return <Card elevation={4} className={classes.terminalListLicenceCard} key={item.chave}>
                    <Grid container spacing={3}>
                        <Grid item xs={4} md={4} lg={4}>
                            <Typography variant="body2">Terminal</Typography>
                        </Grid>
                        <Grid item xs={4} md={4} lg={4}>
                            <Typography variant="body2">{item.chave}</Typography>
                        </Grid>
                        <Grid item xs={4} md={4} lg={4}>
                            <Typography variant="body2">{item.chave_utilizada ? "Ativada" : "Não Ativada"}</Typography>
                        </Grid>
                    </Grid>
                </Card>
            })}
        </>
    )
}